import { ClassSchedule } from 'app/javascript/types';
import { DAY_LABELS, groupByDay } from 'app/javascript/utils/scheduleHelpers';

interface PosterSchedulesProps {
  schedules: ClassSchedule[];
}

const formatTime = (time: string) => time.slice(0, 5);
const MAX_PRINT_SCHEDULES = 18;

export default function PosterSchedules({ schedules }: PosterSchedulesProps) {
  if (schedules.length === 0) return null;

  const grouped = groupByDay(schedules);
  const printableScheduleIds = new Set(schedules.slice(0, MAX_PRINT_SCHEDULES).map((schedule) => schedule.id));
  const hiddenScheduleCount = Math.max(0, schedules.length - MAX_PRINT_SCHEDULES);

  return (
    <div>
      <h2 className="mb-3 border-b-2 border-amber-500 pb-1 text-base font-bold uppercase tracking-widest text-slate-900 print:mb-2 print:text-sm">Horários das aulas</h2>
      <div className="grid grid-cols-1 gap-x-8 gap-y-2 sm:grid-cols-2 print:grid-cols-2 print:gap-y-1">
        {[...grouped.entries()].map(([day, daySchedules]) => (
          <div
            key={day}
            className={`break-inside-avoid ${daySchedules.some((schedule) => printableScheduleIds.has(schedule.id)) ? '' : 'print:hidden'}`}
          >
            <p className="text-sm font-bold text-slate-900 print:text-xs">{DAY_LABELS[day]}</p>
            <ul className="mt-0.5 space-y-0.5 print:space-y-0">
              {daySchedules.map((schedule) => (
                <li
                  key={schedule.id}
                  className={`flex justify-between gap-2 text-sm text-slate-600 print:text-xs ${printableScheduleIds.has(schedule.id) ? '' : 'print:hidden'}`}
                >
                  <span className="truncate">{schedule.name}</span>
                  <span className="tabular-nums shrink-0">
                    {formatTime(schedule.start_time)} – {formatTime(schedule.end_time)}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      {hiddenScheduleCount > 0 && (
        <p className="mt-2 hidden text-xs font-medium text-slate-500 print:block">
          {hiddenScheduleCount === 1
            ? 'Mais 1 horário disponível no app.'
            : `Mais ${hiddenScheduleCount} horários disponíveis no app.`}
        </p>
      )}
    </div>
  );
}
